export const aDeviceInfoBuilder = (props) => {
    return {
        mcuVersion: "A_MCU_VERSION",
        version: "A_VERSION",
        majMin: "A_MAJ_MIN",
        targetId: "0.0",
        isBootloader: false,
        isOSU: true,
        providerName: undefined,
        managerAllowed: false,
        pinValidated: true,
        seFlags: Buffer.alloc(0),
        ...props,
    };
};
//# sourceMappingURL=aDeviceInfo.js.map